export enum StoreFinderMethod {
  NONE = 'NONE',
  SINGLE = 'SINGLE',
  SPLIT = 'SPLIT',
}
